import TermsAndCondition from './TermsAndCondition'

export default TermsAndCondition
